import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import { useTranslation } from "react-i18next";
import { type FieldValues, type UseFormReturn, Path } from "react-hook-form";
import {
  InputOTP,
  InputOTPGroup,
  InputOTPSlot,
} from "@/components/ui/input-otp";

interface MezzaOtpFieldProps<T extends FieldValues> {
  form: UseFormReturn<T>;
  name: keyof T;
  label: string;
  length?: number;
  className?: string;
  autoFocus?: boolean;
  onComplete?: (value: string) => void;
}

export function MezzaOtpField<T extends FieldValues>({
  form,
  name,
  label,
  length = 6,
  className,
  autoFocus,
  onComplete,
}: MezzaOtpFieldProps<T>) {
  const { t } = useTranslation();

  return (
    <FormField
      control={form.control}
      name={name as Path<T>}
      render={({ field }) => (
        <FormItem className={className}>
          <FormLabel>{t(label)}</FormLabel>
          <FormControl>
            <InputOTP
              maxLength={length}
              {...field}
              value={field.value || ""}
              onChange={(value) => {
                field.onChange(value);
                if (value.length === length && onComplete) {
                  onComplete(value);
                }
              }}
              autoFocus={autoFocus}
            >
              <InputOTPGroup>
                {Array.from({ length }).map((_, index) => (
                  <InputOTPSlot
                    key={index}
                    index={index}
                    className={
                      form.formState.errors[name] ? "bg-primary/20" : ""
                    }
                  />
                ))}
              </InputOTPGroup>
            </InputOTP>
          </FormControl>
          <FormMessage className="w-0 min-w-full overflow-hidden text-ellipsis" />
        </FormItem>
      )}
    />
  );
}
